"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const paths_1 = require("@/common/app/paths");
exports.default = vue_1.default.extend({
    name: 'login-home',
    data() {
        return {
            user: undefined,
        };
    },
    mounted() {
        const url = paths_1.paths.API_PROFILE;
        fetch(url)
            .then((resp) => {
            if (!resp.ok) {
                console.error('Unexpected server response: ' + resp.statusText);
                return null;
            }
            return resp.json();
        })
            .then((data) => {
            if (!data)
                return;
            try {
                this.user = data._user.userid;
            }
            catch (e) {
                console.log('Error processing fetch response: ' + e);
            }
        })
            .catch((err) => {
            alert('Error getting session profile data');
            console.error(err);
        });
    },
    computed: {
        loginUrl() {
            const thisUrl = window.location.href;
            const idx = window.location.href.lastIndexOf('/' + paths_1.paths.LOGIN);
            const url = thisUrl.substring(0, idx) + '/' + paths_1.paths.AUTH_DISCORD_CALLBACK;
            const encoded = encodeURI(url);
            return 'https://discord.com/oauth2/authorize?client_id=1326283152448163921&response_type=code&scope=identify&redirect_uri=' + encoded;
        },
        logoutURL() {
            return paths_1.paths.API_LOGOUT;
        },
    },
});
